var _linearGradient, _radialGradient, _linearGradient2, _radialGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _radialGradient3, _linearGradient7, _linearGradient8, _linearGradient9, _radialGradient4, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 40.613,
    x2: 416.54,
    y1: 74.265,
    y2: 450.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb18c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#ff8462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1e00"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 275.814,
    cy: 259.696,
    r: 264.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#ffcfc2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcfc2"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 244.662,
    x2: 287.834,
    y1: 128.088,
    y2: 128.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb281e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb281e"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 275.814,
    cy: 259.696,
    r: 271.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ffcfc2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcfc2"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 362.766,
    x2: 333.728,
    y1: 321.715,
    y2: 350.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb281e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb281e",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 241.586,
    x2: 438.18,
    y1: 65.359,
    y2: 261.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c83ff"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 388.724,
    x2: 378.134,
    y1: 249.52,
    y2: 205.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047e0",
    stopOpacity: 0
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 270.534,
    x2: 305.509,
    y1: 147.235,
    y2: 147.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9ecff",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 273.161,
    cy: 256.614,
    r: 231.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#c9ecff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9ecff"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffed81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#ffd968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ffa629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8804"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 316.004,
    x2: 474.675,
    y1: 174.801,
    y2: 333.473,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 372.758,
    x2: 383.025,
    y1: 221.481,
    y2: 264.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffcf0",
    stopOpacity: 0
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 233.896,
    cy: 217.868,
    r: 269.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#fffcf0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffcf0"
  }))), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 338.142,
    x2: 369.018,
    y1: 329.67,
    y2: 298.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6b06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6b06",
    stopOpacity: 0
  }))), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 176.171,
    x2: 340.11,
    y1: 471.657,
    y2: 500.71,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6b06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6b06",
    stopOpacity: 0
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 256,
    x2: 256,
    y1: -8178.075,
    y2: -8163.764,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -11146.144,
    x2: -11131.876,
    y1: 485.804,
    y2: 485.804,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff2bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff2bd",
    stopOpacity: 0
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 256,
    x2: 256,
    y1: 459.431,
    y2: 473.743,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 174.522,
    x2: 188.79,
    y1: 485.804,
    y2: 485.804,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 176.171,
    x2: 340.11,
    y1: 419.266,
    y2: 448.318,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 256,
    x2: 256,
    y1: -8125.684,
    y2: -8111.372,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -11146.144,
    x2: -11131.876,
    y1: 433.413,
    y2: 433.413,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 256,
    x2: 256,
    y1: 407.039,
    y2: 421.351,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 174.522,
    x2: 188.79,
    y1: 433.413,
    y2: 433.413,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 176.171,
    x2: 340.11,
    y1: 366.874,
    y2: 395.926,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 256,
    x2: 256,
    y1: -8073.292,
    y2: -8058.981,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: -11146.144,
    x2: -11131.876,
    y1: 381.021,
    y2: 381.021,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 256,
    x2: 256,
    y1: 354.648,
    y2: 368.959,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 174.522,
    x2: 188.79,
    y1: 381.021,
    y2: 381.021,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 176.171,
    x2: 340.11,
    y1: 314.482,
    y2: 343.535,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 256,
    x2: 256,
    y1: -8020.9,
    y2: -8006.589,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: -11146.144,
    x2: -11131.876,
    y1: 328.629,
    y2: 328.629,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 256,
    x2: 256,
    y1: 302.256,
    y2: 316.568,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 174.522,
    x2: 188.79,
    y1: 328.629,
    y2: 328.629,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 176.171,
    x2: 340.11,
    y1: 262.091,
    y2: 291.143,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 256,
    x2: 256,
    y1: -7968.509,
    y2: -7954.197,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: -11146.144,
    x2: -11131.876,
    y1: 276.238,
    y2: 276.238,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 256,
    x2: 256,
    y1: 249.864,
    y2: 264.176,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 174.522,
    x2: 188.79,
    y1: 276.238,
    y2: 276.238,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 12.97,
    x2: 176.909,
    y1: 471.657,
    y2: 500.71,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 92.799,
    x2: 92.799,
    y1: -8178.075,
    y2: -8163.764,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: -10982.943,
    x2: -10968.676,
    y1: 485.804,
    y2: 485.804,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 92.799,
    x2: 92.799,
    y1: 459.431,
    y2: 473.743,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 11.322,
    x2: 25.589,
    y1: 485.804,
    y2: 485.804,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 12.97,
    x2: 176.909,
    y1: 419.266,
    y2: 448.318,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 92.799,
    x2: 92.799,
    y1: -8125.684,
    y2: -8111.372,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: -10982.943,
    x2: -10968.676,
    y1: 433.413,
    y2: 433.413,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 92.799,
    x2: 92.799,
    y1: 407.039,
    y2: 421.351,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 11.322,
    x2: 25.589,
    y1: 433.413,
    y2: 433.413,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 339.371,
    x2: 503.31,
    y1: 471.657,
    y2: 500.71,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 419.201,
    x2: 419.201,
    y1: -8178.075,
    y2: -8163.764,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: -11309.345,
    x2: -11295.077,
    y1: 485.804,
    y2: 485.804,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 419.201,
    x2: 419.201,
    y1: 459.431,
    y2: 473.743,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 337.723,
    x2: 351.99,
    y1: 485.804,
    y2: 485.804,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 339.371,
    x2: 503.31,
    y1: 419.266,
    y2: 448.318,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 419.201,
    x2: 419.201,
    y1: -8125.684,
    y2: -8111.372,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: -11309.345,
    x2: -11295.077,
    y1: 433.413,
    y2: 433.413,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 419.201,
    x2: 419.201,
    y1: 407.039,
    y2: 421.351,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 337.723,
    x2: 351.99,
    y1: 433.413,
    y2: 433.413,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 339.371,
    x2: 503.31,
    y1: 366.874,
    y2: 395.926,
    gradientUnits: "userSpaceOnUse",
    href: "#a"
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 419.201,
    x2: 419.201,
    y1: -8073.292,
    y2: -8058.981,
    gradientTransform: "matrix(1 0 0 -1 0 -7662.766)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: -11309.345,
    x2: -11295.077,
    y1: 381.021,
    y2: 381.021,
    gradientTransform: "matrix(-1 0 0 1 -10806.501 0)",
    gradientUnits: "userSpaceOnUse",
    href: "#b"
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 419.201,
    x2: 419.201,
    y1: 354.648,
    y2: 368.959,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 337.723,
    x2: 351.99,
    y1: 381.021,
    y2: 381.021,
    gradientUnits: "userSpaceOnUse",
    href: "#c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M268.54.01C131.13 5.2 21.44 118.67 22.31 257.55 23.2 398.91 137.04 512 278.4 512c67.18 0 128.32-25.87 173.99-68.18 3.95-3.66 4.01-9.9.2-13.71L278.4 255.91V9.57c0-5.4-4.47-9.77-9.86-9.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M268.54.01C131.13 5.2 21.44 118.67 22.31 257.55 23.2 398.91 137.04 512 278.4 512c67.18 0 128.32-25.87 173.99-68.18 3.95-3.66 4.01-9.9.2-13.71L278.4 255.91V9.57c0-5.4-4.47-9.77-9.86-9.56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m278.66 256.18-.27-.27V9.57c0-5.39-4.46-9.76-9.85-9.56a255 255 0 0 0-33.05 3.41v252.76z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M268.54.01C131.13 5.2 21.44 118.67 22.31 257.55 23.2 398.91 137.04 512 278.4 512c67.18 0 128.32-25.87 173.99-68.18 3.95-3.66 4.01-9.9.2-13.71L278.4 255.91V9.57c0-5.4-4.47-9.77-9.86-9.56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M452.6 430.1 278.39 255.91l-61.82.27 207.86 210.11c9.84-6.84 19.19-14.35 27.95-22.47 3.96-3.67 4.03-9.91.22-13.72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M489.52 203.75c-22.89-92.96-105.55-162.4-204.9-165.19-3.4-.1-6.22 2.63-6.22 6.03v211.32l206.54-44.81c3.32-.72 5.39-4.04 4.58-7.35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M489.51 203.75c-2.7-10.97-6.22-21.62-10.54-31.85-.51.29-1.08.52-1.69.64l-198.9 43.15v40.21l206.55-44.81c3.33-.7 5.4-4.03 4.58-7.34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M284.61 38.56c-3.39-.1-6.22 2.62-6.22 6.03V255.9l42.72-9.26V44.6c0-.66.1-1.29.29-1.87-11.94-2.4-24.22-3.81-36.79-4.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M489.51 203.75C466.62 110.8 383.97 41.36 284.61 38.56c-3.39-.1-6.22 2.62-6.22 6.03v31.62c79.38 12.82 144.36 68.62 170.3 142.75l36.25-7.86c3.32-.71 5.39-4.04 4.57-7.35"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m473.51 213.59-195.12 42.32L411.9 389.42c38.71-40.44 62.5-95.29 62.5-155.69 0-6.78-.31-13.5-.89-20.14"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m473.51 213.59-195.12 42.32 30.69 30.69 164.65-35.71c.43-5.66.66-11.39.66-17.16 0-6.79-.31-13.5-.88-20.14"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m473.51 213.59-195.12 42.32L411.9 389.42c38.71-40.44 62.5-95.29 62.5-155.69 0-6.78-.31-13.5-.89-20.14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m319.56 246.98-41.18 8.93L411.9 389.42a227 227 0 0 0 22.52-27.58z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M325.36 512H186.64c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M337.6 497.62v2.14c0 6.76-5.48 12.24-12.24 12.24H186.64c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M322.43 459.61h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M337.6 473.99v-2.14c0-6.76-5.48-12.24-12.24-12.24H186.64c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M189.57 459.61h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M325.36 459.61H186.64c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M337.6 445.23v2.14c0 6.76-5.48 12.24-12.24 12.24H186.64c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M322.43 407.22h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M337.6 421.59v-2.14c0-6.76-5.48-12.24-12.24-12.24H186.64c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M189.57 407.22h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M325.36 407.22H186.64c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M337.6 392.84v2.14c0 6.76-5.48 12.24-12.24 12.24H186.64c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M322.43 354.83h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M337.6 369.2v-2.14c0-6.76-5.48-12.24-12.24-12.24H186.64c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M189.57 354.83h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M325.36 354.83H186.64c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.75-5.48 12.24-12.24 12.24"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M337.6 340.45v2.14c0 6.76-5.48 12.24-12.24 12.24H186.64c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M322.43 302.43h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M337.6 316.81v-2.14c0-6.76-5.48-12.24-12.24-12.24H186.64c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M189.57 302.43h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M325.36 302.43H186.64c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M337.6 288.06v2.14c0 6.76-5.48 12.24-12.24 12.24H186.64c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M322.43 250.04h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M337.6 264.42v-2.14c0-6.76-5.48-12.24-12.24-12.24H186.64c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M189.57 250.04h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M162.16 512H23.44c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M174.4 497.62v2.14c0 6.76-5.48 12.24-12.24 12.24H23.44c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M159.23 459.61h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M174.4 473.99v-2.14c0-6.76-5.48-12.24-12.24-12.24H23.44c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M26.37 459.61h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M162.16 459.61H23.44c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M174.4 445.23v2.14c0 6.76-5.48 12.24-12.24 12.24H23.44c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M159.23 407.22h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M174.4 421.59v-2.14c0-6.76-5.48-12.24-12.24-12.24H23.44c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M26.37 407.22h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M488.56 512H349.84c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M500.8 497.62v2.14c0 6.76-5.48 12.24-12.24 12.24H349.84c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M485.63 459.61h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M500.8 473.99v-2.14c0-6.76-5.48-12.24-12.24-12.24H349.84c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M352.77 459.61h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M488.56 459.61H349.84c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M500.8 445.23v2.14c0 6.76-5.48 12.24-12.24 12.24H349.84c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M485.63 407.22h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M500.8 421.59v-2.14c0-6.76-5.48-12.24-12.24-12.24H349.84c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M352.77 407.22h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M488.56 407.22H349.84c-6.76 0-12.24-5.48-12.24-12.24v-27.91c0-6.76 5.48-12.24 12.24-12.24h138.72c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M500.8 392.84v2.14c0 6.76-5.48 12.24-12.24 12.24H349.84c-6.76 0-12.24-5.48-12.24-12.24v-2.14z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M485.63 354.83h2.92c6.76 0 12.24 5.48 12.24 12.24v27.91c0 6.76-5.48 12.24-12.24 12.24h-2.92z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M500.8 369.2v-2.14c0-6.76-5.48-12.24-12.24-12.24H349.84c-6.76 0-12.24 5.48-12.24 12.24v2.14z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M352.77 354.83h-2.92c-6.76 0-12.24 5.48-12.24 12.24v27.91c0 6.76 5.48 12.24 12.24 12.24h2.92z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.d3ca7dea6fc3f2caf9ea519be182e3a3.svg";
export { ForwardRef as ReactComponent };